import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Chip, stepClasses } from '@mui/material';
import usePlanStore from '../../store/planStore';

const PlanList = ({ onPlanSelect }) => {
  const [selectedPlan, setSelectedPlan] = useState('');
  const { fetchPlans, allPlan, fetchPlan, selectPlan } = usePlanStore(); // You'll need to add this to your store
  
  useEffect(() => {
    fetchPlans();
  }, []);
  
  const handlePlanChange = (event) => {
    const planId = event.target.value;

    const plan = allPlan.find(p => p.id === planId);
    if (plan) {
      fetchPlan(plan.id);
      selectPlan(plan.id);
      setSelectedPlan(plan.id);
      onPlanSelect(
        { startOfWeek: plan.start_date, endOfWeek: plan.end_date }
      )
    }
  };
  
  // Group plans by type
  const weeklyPlans = allPlan.filter(plan => plan.mode === 'weekly').sort((a, b) => a.start_date < b.start_date);
  const eventPlans = allPlan.filter(plan => plan.mode === 'event').sort((a, b) => a.start_date < b.start_date);

  return (
    <Box sx={{ minWidth: 200, mb: 2 }}>
      <FormControl fullWidth>
        <InputLabel>Select Plan</InputLabel>
        <Select
          value={selectedPlan}
          label="Select Plan"
          onChange={handlePlanChange}
        >
          {/* Group by plan type */}
          <MenuItem disabled>Weekly Plans</MenuItem>
          {weeklyPlans.map((plan) => (
            <MenuItem key={plan.id} value={plan.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                📅 {plan.start_date} - {plan.end_date}
              </Box>
            </MenuItem>
          ))}
          
          <MenuItem disabled>Event Plans</MenuItem>
          {eventPlans.map((plan) => (
            <MenuItem key={plan.id} value={plan.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                🎉 {plan.event_name} ({plan.guestCount} guests)
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PlanList;